import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingComponent from './LoadingComponent';
import moment from 'moment';
import { getUser, getUserProfile } from '../actions/userAction';
import { receivedBrandAwarenessData, receivedAdAwarenessData, receivedBrandConsiderationData, receivedBrandData, didRequestInitialData, initTelescopeData, receivedTelescopeData, setEndDate, setStartDate, setAvailableDates} from '../actions/dataAction';
import styled from 'styled-components';
import ViewController from './ViewController.js';
import Launcher from './dataViews/insights/Launcher';

const ColoredBackground = styled.div`
  position: fixed;
  top:0;
  left:0;
  bottom:0;
  right:0;
  overflow-y: scroll;
  background: #16364f;
  background: -moz-linear-gradient(top, #16364f 0%, #293859 50%, #c55867 100%) fixed;
  background: -webkit-linear-gradient(top, #16364f 0%, #293859 50%, #c55867 100%) fixed;
  background: -webkit-gradient(linear, left top, left bottom, from(#16364f), color-stop(50%, #293859), to(#c55867)) fixed;
  background: -o-linear-gradient(top, #16364f 0%, #293859 50%, #c55867 100%) fixed;
  background: linear-gradient(to bottom, #16364f 0%, #293859 50%, #c55867 100%) fixed;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#16364f', endColorstr='#c55867',GradientType=0 ) fixed;

  /*overflow: hidden;*/

  @media print {
    position: relative;
  }
`;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  initBrand(brand) {
    const _this = this;
    let Telescope = window.Telescope;
    const ts = new Telescope({brand: brand});

    ts.sync().then(() => {
      ts.date = moment().format('YYYY-MM-DD');
      ts.on('data', data => {
        if (!data || !(Object.keys(data).length === 0 && data.constructor === Object)) {
          _this.props.receivedBrandData(brand, data);
        }
      });
    });
  }

  initAdditionalBrands(client) {
    let brands = this.props.user && this.props.user.userProfile && this.props.user.userProfile.brands;
    if (brands && brands.length) {
      brands.forEach((brand,i) => {
        if (brand !== client) {
          this.initBrand(brand);
        }
      });
    }
  }

  initTelescope(client) {
    let Telescope = window.Telescope;
    let startDate = new Date(new Date().getFullYear() - 1, 0, 1);

    if (Telescope && client) {
      const ts = new Telescope({brand: client});
      this.props.initTelescopeData(ts);

      ts.range.then(([start, end]) => {
        const firstAvailableDate = moment(start).toDate();
        const lastAvailableDate = moment(end).toDate();

        startDate = moment(lastAvailableDate).subtract(1, 'year')

        this.props.setStartDate(startDate);
        this.props.setEndDate(lastAvailableDate);
        this.props.setAvailableDates({start: firstAvailableDate, end: lastAvailableDate});
      });

      ts.on('data', data => {
        if (!data || !(Object.keys(data).length === 0 && data.constructor === Object)) {
          this.props.receivedTelescopeData(data);
        }
      });
      ts.sync().then(() => {
        ts.range.then(([start, end]) => {
          const firstAvailableDate = moment(start).toDate();
          const lastAvailableDate = moment(end).toDate();
          this.props.setStartDate(startDate);
          this.props.setEndDate(lastAvailableDate);
          this.props.setAvailableDates({start: firstAvailableDate, end: lastAvailableDate});
        });

        ts.on('data', data => {
          if (!data || !(Object.keys(data).length === 0 && data.constructor === Object)) {
            this.props.receivedTelescopeData(data);
          }
        });
      });
    }
  }

  componentWillReceiveProps(props) {
    if (!this.props.user.userProfileLoaded) {
      this.props.getUserProfile();
    }

    if (this.props.user.userProfileLoaded && !this.props.data.didRequestInitialData && !this.state.didRequestInitialData) {
      const client = props.user.userProfile && props.user.userProfile.client.toLowerCase();
      this.initTelescope(client);
      this.initAdditionalBrands(client);
      this.setState({didRequestInitialData: true});
      this.props.didRequestInitialData();
    }
  }

  insightsLauncher() {
    const insightsEnabled = false;
    if (insightsEnabled && process.env.REACT_APP_INSIGHTS_ACTIVE === "true") {
      return <Launcher/>;
    }
  }

  render() {
    const { match, user } = this.props;

    return (
      <ColoredBackground>
        <div className="container-fluid" style={{maxWidth:'2000px'}}>

          <div className="row">
            <ViewController match={match} />
          </div>
        </div>

        {this.insightsLauncher()}
      </ColoredBackground>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    data: state.data
  };
}

export default connect(mapStateToProps, { receivedBrandData, getUser, getUserProfile, didRequestInitialData, initTelescopeData, receivedTelescopeData, setEndDate, setStartDate, setAvailableDates, receivedBrandAwarenessData, receivedAdAwarenessData, receivedBrandConsiderationData })(App);



// WEBPACK FOOTER //
// ./src/components/App.js